import { Component } from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../decorators'
import Exam from '../../../../lib/IssueMapping/Exam'
import { PEQuestionnaire } from '../../../../lib/Questionnaires'
import IssueQueuer from '../../../shared/IssueQueuer'
import { CircularProgress } from '../../../shared/NarusMaterial'
import * as Actions from '../lib/new-actions'

import PE from './form'

import './styles.scss'

const CATEGORY = 'Physical Exam'

class PhysicalExam extends Component {
  UNSAFE_componentWillMount () {
    this.resetForm()
  }

  handleSubmit = data => {
    const { dispatch, params, currentUser, encounter } = this.props
    this.queueIssues(data)

    dispatch(
      Actions.createAssessment(
        data,
        params.id,
        currentUser.id,
        CATEGORY,
        encounter.document.context_id,
        PEQuestionnaire
      )
    )
  }

  resetForm = () => {
    const { encounter, dispatch, params } = this.props
    const contextId =
      encounter && encounter.document && encounter.document.context_id

    dispatch(
      Actions.getAssessment(params.id, CATEGORY, PEQuestionnaire, contextId)
    )
  }

  queueIssues = data => {
    const { dispatch, patientId, practitionerId, encounterId } = this.props
    const iq = new IssueQueuer({
      dispatch,
      patientId,
      practitionerId,
      encounterId
    })

    iq.queueIssues({
      mapping: Exam,
      currentForm: data,
      existingForms: undefined
    })
  }

  render () {
    const { questionnaire } = this.props
      const formData = questionnaire?.[CATEGORY]?.formData ?? {}
      const loading = questionnaire?.[CATEGORY]?.loading

    return (
      <div className='main physical-exam-page'>
        <h1>Physical Exam</h1>
        {loading
          ? (
            <CircularProgress />
          )
          : (
            <PE
              onSubmit={this.handleSubmit}
              initialValues={formData}
              cancel={this.resetForm}
            />
          )}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  questionnaire: redux.questionnaire,
  encounter: redux.encounter?.encounter,
  currentUser: redux.users.current_user,
  practitionerId: redux.auth.profile.sub,
  patientId: redux.globalVars.params.id,
  encounterId: redux.encounter?.encounter?.id
})

export default connect(mapStateToProps)(withLegacyRouter(PhysicalExam))
